import { endPoint } from "./base.config";

export const companyService = {
  add: `${endPoint}company-services`,
  update: `${endPoint}company-services/:id`,
  fetchAll: `${endPoint}company-services`,
  paymentStatusV2: `${endPoint}company-services/:companyId/payment-status`,
  listActiveCompanyServices: `${endPoint}company-services/:companyId/list-active-services`,
  buyZtlService: `${endPoint}company-services/:companyId/buy-ztl-service`,
  // fiken
  addUpdateFikenIntegration: `${endPoint}company-services/fiken-integration`,
  getFikenIntegration: `${endPoint}company-services/fiken-integration`,
}